/*
 * @Author: Qian.qianchen
 * @Date:   2018-08-24
 */

'use strict';
/**
 *  Module
 *
 * Description
 */
angular.module('whiteListManageServiceModule', [
        'addPapersiteModule',
        'addWhiteListUserModule'
    ])
    .factory('whiteListManageService', ["$modal", "$q", function($modal, $q) {
        return {
            /**
             * [addPapersite description] 新增媒体
             */
            addPapersite: function() {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/tenantManageMent/whiteListManage/service/addPapersite/addPapersite_tpl.html",
                    windowClass: 'add-papersite-window',
                    backdrop: false,
                    controller: "addPapersiteCtrl",
                    resolve: {

                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
            /**
             * [getUser description：获取用户]
             * @param  {[fn]} success  [description:回调函数]
             * @param  {[obj]} 传入参数 [description：参数属性 rightFilter:是否权限过滤组织树]
             * @return {[type]}             [description]
             */
            getUser: function(success, params, selectedUser) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/tenantManageMent/whiteListManage/service/addWhiteListUser/addWhiteListUser_tpl.html",
                    windowClass: 'addWhiteListUserTransfer',
                    backdrop: false,
                    controller: "addWhiteListUserCtrl",
                    resolve: {
                        params: function() {
                            return params;
                        },
                        selectedUser: function() {
                            return selectedUser;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
        };
    }]);